let loading = false;

function initInfiniteScroll() {
  const grid = document.querySelector("#product-grid");
  if (!grid) return;

  window.addEventListener("scroll", onScroll);
}

async function onScroll() {
  if (loading) return;

  if ((window.innerHeight + window.scrollY) < (document.body.offsetHeight - 700))
    return;

  const next = document.querySelector(".pagination__item--prev");

  if (!next) return;

  loading = true;

  try {

    const response = await fetch(next.href);

    const html = await response.text();

    const parser = new DOMParser();

    const doc = parser.parseFromString(html, "text/html");

    const newItems = doc.querySelectorAll("#product-grid .grid__item");

    const grid = document.querySelector("#product-grid");

    newItems.forEach(item => {
      grid.appendChild(item);
    });

    const oldPagination = document.querySelector(".pagination-wrapper");
    const newPagination = doc.querySelector(".pagination-wrapper");

    if (newPagination) {
      oldPagination.replaceWith(newPagination);
    } else if (oldPagination) {
      oldPagination.remove();
      window.removeEventListener("scroll", onScroll);
    }

  } catch (e) {
    console.error(e);
  }

  loading = false;
}

document.addEventListener("DOMContentLoaded", initInfiniteScroll);

document.addEventListener("shopify:section:load", initInfiniteScroll);